import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Context provider
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/ui/Toast';

// Layout components
import Layout from './components/layout/Layout';

// Page components
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import DatasetDetailsPage from './pages/DatasetDetailsPage';
import CreateDatasetPage from './pages/CreateDatasetPage';
import TestPage from './pages/TestPage';
import NotFoundPage from './pages/NotFoundPage';

// Auth protection component
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />

            {/* Protected routes within layout */}
            <Route element={<Layout />}>
              <Route 
                path="/" 
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/datasets/create" 
                element={
                  <ProtectedRoute>
                    <CreateDatasetPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/datasets/:id" 
                element={
                  <ProtectedRoute>
                    <DatasetDetailsPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/test/:datasetId" 
                element={
                  <ProtectedRoute>
                    <TestPage />
                  </ProtectedRoute>
                } 
              />
            </Route>

            {/* 404 route */}
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;